import 'slick-carousel';

function heroPOS() {
  $('.page-hero__links').css({
    left: $('.page-hero__content-left-heading--sublead').offset().left,
  });
}

function sliderPOS() {
  $('.content-cta__slider-item-count').css({
    width: $('.content-cta__slider-item-img').width(),
  });
  $('.content-cta__slider-item-lead').css({
    width: $('.content-cta__slider-item-img').width(),
  });
  $('.content-cta__slider-item-sublead').css({
    width: $('.content-cta__slider-item-img').width(),
  });
}

export default {
  init() {},
  finalize() {
    $('.content-cta__slider').slick({
      infinite: true,
      slidesToScroll: 1,
      slidesToShow: 1,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 4000,
    });

    if (window.matchMedia('(min-width: 1024px)').matches) {
      setTimeout(function() {
        sliderPOS();
        heroPOS();
      }, 1500);
    }

    $(window).resize(function() {
      sliderPOS();
      heroPOS();
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js